module.exports = __webpack_public_path__ + "static/Mordor-46c890c2a796a788d01f25bcae097e37.jpg";